module.exports = __webpack_public_path__ + "static/modal-9dbd1867a6128d6803c6a41ee0d9505a.mp4";